import { SemiBoldText } from '../../../../utils/typography/BaseText';

export const StaySmallSmallFavorites = () => {
  return (
    <div className="px-2 lg:px-6">
      <SemiBoldText>Favorites</SemiBoldText>
      <hr />
    </div>
  );
};
